import { Card, Col, Flex, FloatButton, Row } from "antd";
import { FolderOpenOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useEffect } from "react";
import { getAllProjects } from "../../features/projects/projectSlice";

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const projectsCount = useSelector((state: RootState) => state.project.projects.length);

  useEffect(() => {
    if (!projectsCount) {
      dispatch(getAllProjects() as any);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{ minHeight: "calc(100vh - 70px)", width: "100%", padding: "0 16px" }}
    >
      <Row gutter={[24, 24]} justify="center" style={{ width: "100%", margin: 0 }}>
        {projectsCount > 0 ? (
          <Col xs={24} sm={12} md={8} style={{ display: "flex", justifyContent: "center" }}>
            <Card hoverable onClick={() => navigate("/proyectos")} style={{ minWidth: 280 }}>
              <Flex vertical align="center" gap={8}>
                <FolderOpenOutlined style={{ fontSize: 32 }} />
                <div>Ver Proyectos</div>
              </Flex>
            </Card>
          </Col>
        ) : null}
        <Col xs={24} sm={12} md={8} style={{ display: "flex", justifyContent: "center" }}>
          <Card hoverable onClick={() => navigate("/proyecto/nuevo")} style={{ minWidth: 280 }}>
            <Flex vertical align="center" gap={8}>
              <PlusCircleOutlined style={{ fontSize: 32 }} />
              <div>Crear Proyecto</div>
            </Flex>
          </Card>
        </Col>
      </Row>
      <FloatButton onClick={() => navigate("/proyecto/nuevo")} icon={<PlusCircleOutlined />} type="primary" style={{ insetInlineEnd: 40 }} />
    </Flex>
  );
}

export default Dashboard;
